import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { Toast } from "primereact/toast";
import { useParams } from "react-router-dom";
import MeaButton from "../../../../components/MeaButton";
import slotChangeRequestsAPI from "../../../../services/slot_change_requests";

const RejectSlotChangeRequestModal = forwardRef((props, ref) => {
  const params = useParams();
  const schoolId = props.schoolId || params.schoolId;
  const trainingId = props.trainingId || params.trainingId;
  const accessToken = "";

  const toast = useRef();
  const [visible, setVisible] = useState(false);
  const [reason, setReason] = useState("");
  const [request, setRequest] = useState(null);
  const [callbackFn, setCallbackFn] = useState(() => {});
  const [loading, setLoading] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("Refuser la demande");
  const [submitLabel, setSubmitLabel] = useState("Refuser");
  const [successMessage, setSuccessMessage] = useState("Demande refusée");

  useImperativeHandle(ref, () => ({
    show: (item, callback, initialReason = "", options = {}) => {
      setRequest(item);
      setReason(initialReason || "");
      setDialogTitle(options?.title || "Refuser la demande");
      setSubmitLabel(options?.submitLabel || "Refuser");
      setSuccessMessage(options?.successMessage || "Demande refusée");
      setCallbackFn(() => callback);
      setVisible(true);
    },
  }));

  const handleReject = () => {
    setLoading(true);
    slotChangeRequestsAPI
      .RejectOne(schoolId, trainingId, accessToken, request?.id, reason)
      .then(() => {
        toast.current.show({
          severity: "success",
          summary: "Succès",
          detail: successMessage,
        });
        setVisible(false);
        callbackFn?.();
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: err.message,
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Toast ref={toast} position="bottom-center" />
      <Dialog
        header={dialogTitle}
        visible={visible}
        style={{ width: "30vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        onHide={() => setVisible(false)}
        footer={
          <div>
            <MeaButton
              label="Annuler"
              icon="pi pi-times"
              className="p-button-text"
              disabled={loading}
              onClick={() => setVisible(false)}
            />
            <MeaButton
              label={submitLabel}
              icon="pi pi-times-circle"
              severity="danger"
              loading={loading}
              onClick={handleReject}
            />
          </div>
        }
      >
        <label className="block text-900 font-medium mb-2">Motif du refus</label>
        <InputTextarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={3}
          className="w-full"
          placeholder="Optionnel"
        />
      </Dialog>
    </>
  );
});

export default RejectSlotChangeRequestModal;
